import React from 'react';
import { useLocation } from 'react-router-dom';

import Footer from '../Footer';
import MessengersButton from '../MessengersButton/MessengersButton';
import Header from '../header/Header';

import css from './auth.css';

const Auth = (props) => {
    const location = useLocation();
    return (
        <div className={css.root}>
            <Header
                excludedRegistrationButton={location.pathname.startsWith(
                    '/auth/registration',
                )}
                typeStatic
                registrationParams={location.search}
            />

            <div className={css.container}>
                <div className={css.wrapper}>{props.children}</div>
            </div>
            <MessengersButton />
            <Footer />
        </div>
    );
};

export default Auth;
